import React from 'react';
import PropTypes from 'prop-types';
import '../css/alert.css';

export const formatContentWithEmoji = (content, emoji) => {
  return (
    <span>
      <span role="img" aria-label="" className="mr-3">{emoji}</span>
      {content}
    </span>
  );
};

export default class Alert extends React.PureComponent {
  static propTypes = {
    type: PropTypes.oneOf(['success', 'warning', 'reminder']),
    className: PropTypes.string,
    autoCloseDelay: PropTypes.number,
    onClose: PropTypes.func
  }

  static defaultProps = {
    type: 'reminder',
    className: ''
  }

  state = {
    visible: true
  }

  componentDidMount() {
    const { autoCloseDelay } = this.props;
    if (autoCloseDelay) {
      setTimeout(this.onAutoClose, autoCloseDelay);
    }
  }

  onAutoClose = () => {
    const { onClose } = this.props;
    this.setState({ visible: false });
    if (onClose) onClose();
  }

  render() {
    const { onClose, children, type, className } = this.props;

    if (!this.state.visible) return null;

    return (
      <div className={`alert alert-${type} ${className} show`}>
        {!!onClose && (
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={onClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        )}

        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/desktop/components/alert.js